<!-- src/domains/spl-navegantes/views/ReportBeneficiarios.vue -->
<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import SearchSelect from "@/core/components/SearchSelect"
  import Select from "@/core/components/Select"
  import BeneficiariosReportList from "@/domains/spl-navegantes/partials/BeneficiariosReportList.vue"

  const UTF8REGEX = /filename\*\s*=\s*UTF-8''([^;]+)/i
  const notutf8Regex = /filename\s*=\s*("?)([^";]+)\1/i

  export default {
    components: {
      Breadcrumbs,
      Select,
      SearchSelect,
      BeneficiariosReportList,
    },
    data() {
      const hoje = new Date()

      const formatDate = (data) => {
        const ano = data.getFullYear()
        const mes = String(data.getMonth() + 1).padStart(2, "0")
        const dia = String(data.getDate()).padStart(2, "0")
        return `${ano}-${mes}-${dia}`
      }

      const inicial = new Date(hoje)
      const final = new Date(hoje)
      inicial.setFullYear(inicial.getFullYear() - 1)
      final.setFullYear(final.getFullYear() + 1)

      return {
        title: "Relatório de Beneficiários",
        crumbs: [
          { name: "Início", path: "index" },
          { name: "SPL Navegantes", path: "spl-navegantes.index" },
          {
            name: "Relatório de Beneficiários",
            path: "spl-navegantes.relatorios.beneficiarios",
          },
        ],
        pdfLoading: false,

        // filtros
        search: "",

        // escala: somente "12x36" e "normal"
        escala: "",
        escalaOptions: [
          { id: "", name: "" },
          { id: 12, name: "12x36" },
          { id: 0, name: "Normal" },
        ],

        // período (datas completas)
        periodo_inicial: formatDate(inicial),
        periodo_final: formatDate(final),

        // situação
        situacao_id: "",
        situacaoOptions: [
          { id: "", name: "" },
          { id: "1", name: "Iniciado" },
          { id: "2", name: "Analisado" },
          { id: "3", name: "Ativo" },
          { id: "4", name: "Vencido" },
          { id: "5", name: "Pendente" },
          { id: "6", name: "Cancelado" },
          { id: "7", name: "A Vencer" },
        ],

        // multiselect
        modalidade_id: "",
        modalidadeOptions: [
          { id: "", name: "" },
          { id: "1", name: "Pedestre" },
          { id: "2", name: "Ciclista" },
          { id: "3", name: "Motociclista" },
        ],

        categoria_id: "",
        categoriaOptions: [
          { id: "", name: "" },
          { id: "1", name: "Estudante" },
          { id: "2", name: "Trabalhador" },
          { id: "3", name: "Estagiário" },
        ],

        // órgão/instituição
        instituicao_nome: "",

        // município
        municipio_id: "",
        municipioOptions: [
          { id: "", name: "" },
          { id: "4540", name: "Itajaí" },
          { id: "4583", name: "Navegantes" },
        ],
      }
    },

    computed: {
      filters() {
        return {
          search: this.search,
          escala: this.escala,
          periodo_inicial: this.periodo_inicial,
          periodo_final: this.periodo_final,

          situacao_id: this.situacao_id,

          modalidade_id: this.modalidade_id,
          categoria_id: this.categoria_id,

          instituicao_nome: this.instituicao_nome,
          municipio_id: this.municipio_id,
        }
      },
    },

    mounted() {
      document.title = `${this.title} - ${process.env.VUE_APP_TITLE}`
    },

    methods: {
      mapSituacaoLabel(id) {
        switch (String(id)) {
          case "1":
          case "2":
            return "ANALISADO"
          case "3":
            return "ATIVO"
          case "4":
            return "VENCIDO"
          case "5":
            return "PENDENTE"
          case "6":
            return "CANCELADO"
          case "7":
            return "A VENCER"
          default:
            return `Situação #${id}`
        }
      },

      async clearFilters() {
        const hoje = new Date()

        const formatDate = (data) => {
          const ano = data.getFullYear()
          const mes = String(data.getMonth() + 1).padStart(2, "0")
          const dia = String(data.getDate()).padStart(2, "0")
          return `${ano}-${mes}-${dia}`
        }

        const inicial = new Date(hoje)
        const final = new Date(hoje)
        inicial.setFullYear(inicial.getFullYear() - 1)
        final.setFullYear(final.getFullYear() + 1)

        this.search = ""
        this.escala = ""
        this.periodo_inicial = formatDate(inicial)
        this.periodo_final = formatDate(final)

        this.situacao_id = ""
        this.modalidade_id = ""
        this.categoria_id = ""
        this.instituicao_nome = ""
        this.municipio_id = ""

        await this.$nextTick()
        this.$refs.list?.resetAndReload?.()
      },

      async submit() {
        await this.$nextTick()
        this.$refs.list?.resetAndReload?.()
      },

      buildReportPayload() {
        const f = this.filters || {}
        return {
          search: f.search ? String(f.search).trim() : null,
          filters: {
            situacao: f.situacao_id ? [String(f.situacao_id)] : [],
            categoria: f.categoria_id ? [String(f.categoria_id)] : [],
            modalidade: f.modalidade_id ? [String(f.modalidade_id)] : [],
            instituicao_nome: f.instituicao_nome
              ? String(f.instituicao_nome).trim()
              : null,
            municipio: f.municipio_id ? [String(f.municipio_id)] : [],
            escala:
              f.escala !== "" && f.escala != null ? [String(f.escala)] : [],
            periodo_inicial: f.periodo_inicial || null,
            periodo_final: f.periodo_final || null,
          },
          orderBy: { nmnome: "DESC" },
        }
      },

      getFilenameFromDisposition(disposition) {
        if (!disposition) {
          return null
        }

        // tenta filename*=UTF-8''...
        const utf8Match = disposition.match(UTF8REGEX)
        if (utf8Match?.[1]) {
          try {
            return decodeURIComponent(utf8Match[1].replace(/["']/g, ""))
          } catch (e) {
            return utf8Match[1].replace(/["']/g, "")
          }
        }

        // tenta filename="..."
        const match = disposition.match(notutf8Regex)
        return match?.[2] ? match[2] : null
      },

      async blobToText(blob) {
        try {
          return await blob.text()
        } catch (e) {
          return "Erro ao processar resposta do servidor."
        }
      },

      forceDownloadBlob(blob, filename) {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.download = filename || "relatorio_beneficiarios.pdf"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      },

      async gerarArquivo() {
        if (this.pdfLoading) {
          return
        }

        try {
          this.pdfLoading = true
          document.body.style.cursor = "wait"
          this.$Progress.start()

          const payload = this.buildReportPayload()

          const resp = await this.$axios.post(
            "/api/spl-navegantes/beneficiarios/relatorio/pdf",
            payload,
            {
              responseType: "blob",
              headers: { Accept: "application/pdf" },
              timeout: 0,
            }
          )

          const contentType =
            resp.headers?.["content-type"] ||
            resp.headers?.["Content-Type"] ||
            ""

          if (!String(contentType).toLowerCase().includes("application/pdf")) {
            const msg = await this.blobToText(resp.data)
            this.$toast?.error?.({ message: msg || "Erro ao gerar PDF." })
            return
          }

          const disposition =
            resp.headers?.["content-disposition"] ||
            resp.headers?.["Content-Disposition"]

          const filename =
            this.getFilenameFromDisposition(disposition) ||
            "relatorio_beneficiarios.pdf"

          this.forceDownloadBlob(resp.data, filename)
        } catch (e) {
          const data = e.response?.data
          if (data instanceof Blob) {
            const msg = await this.blobToText(data)
            this.$toast?.error?.({ message: msg || "Erro ao gerar PDF." })
          } else {
            this.$toast?.error?.({
              message: e.response?.data?.error || "Erro ao gerar PDF.",
            })
          }
        } finally {
          this.pdfLoading = false
          document.body.style.cursor = ""
          this.$Progress.finish()
        }
      },
    },
  }
</script>

<template>
  <div class="w-full bg-gray-light">
    <div
      v-if="pdfLoading"
      class="fixed inset-0 z-50 flex items-center justify-center"
      style="background: rgba(255,255,255,.75); cursor: wait;"
    >
      <div class="bg-white border rounded px-6 py-4 shadow">
        <div class="text-sm font-semibold">
          Relatório sendo gerado, aguarde...
        </div>
        <div class="text-xs text-gray-600 mt-1">
          Isso pode levar alguns minutos.
        </div>
      </div>
    </div>

    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-6" :crumbs="crumbs"/>

      <form
        @submit.prevent="submit"
        class="grid grid-cols-12 gap-x-6 gap-y-4 text-xs items-end"
      >
        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">BUSCA</label>
          <input
            v-model="search"
            :disabled="pdfLoading"
            class="pl-4 filter-search h-[38px]"
            type="text"
            placeholder="Nome/Matrícula"
          >
        </div>

        <div class="col-span-12 md:col-span-1 flex flex-col row-gap-2">
          <label class="filter-label">ESCALA</label>
          <Select
            class="w-full"
            selectClass="form-select filter-select h-[38px]"
            :options="escalaOptions"
            :selected.sync="escala"
          />
        </div>

        <div class="col-span-12 md:col-span-2 flex flex-col row-gap-2">
          <label class="filter-label">SITUAÇÃO</label>
          <Select
            class="w-full"
            selectClass="form-select filter-select h-[38px]"
            :options="situacaoOptions"
            :selected.sync="situacao_id"
          />
        </div>

        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">PERÍODO INICIAL</label>
          <input
            v-model="periodo_inicial"
            :disabled="pdfLoading"
            class="pl-4 filter-search h-[38px]"
            type="date"
            min="2000-01-01"
            max="2100-12-31"
          >
        </div>

        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">PERÍODO FINAL</label>
          <input
            v-model="periodo_final"
            :disabled="pdfLoading"
            class="pl-4 filter-search h-[38px]"
            type="date"
            min="2000-01-01"
            max="2100-12-31"
          >
        </div>

        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">MODALIDADE</label>
          <Select
            class="w-full"
            selectClass="form-select filter-select h-[38px]"
            :options="modalidadeOptions"
            :selected.sync="modalidade_id"
          />
        </div>

        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">CATEGORIA</label>
          <Select
            class="w-full"
            selectClass="form-select filter-select h-[38px]"
            :options="categoriaOptions"
            :selected.sync="categoria_id"
          />
        </div>

        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">ÓRGÃO</label>
          <input
            v-model="instituicao_nome"
            :disabled="pdfLoading"
            class="pl-4 filter-search h-[38px]"
            type="text"
            placeholder="Digite parte do nome da empresa"
          >
        </div>

        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">MUNICÍPIO</label>
          <Select
            class="w-full"
            selectClass="form-select filter-select h-[38px]"
            :options="municipioOptions"
            :selected.sync="municipio_id"
          />
        </div>

        <div class="col-span-12 flex items-center justify-end gap-3 mt-1">
          <button
            type="button"
            class="btn-outline-green"
            :disabled="pdfLoading"
            :class="{ 'opacity-60 cursor-not-allowed': pdfLoading }"
            @click="gerarArquivo"
          >
            <span v-if="!pdfLoading">GERAR ARQUIVO</span>
            <span v-else>GERANDO...</span>
          </button>

          <button
            type="button"
            class="btn-outline-green"
            :disabled="pdfLoading"
            :class="{ 'opacity-60 cursor-not-allowed': pdfLoading }"
            @click="clearFilters"
          >
            LIMPAR FILTROS
          </button>

          <button
            type="submit"
            class="btn-green-solid"
            :disabled="pdfLoading"
            :class="{ 'opacity-60 cursor-not-allowed': pdfLoading }"
          >
            PESQUISAR
          </button>
        </div>
      </form>

      <div class="mt-6">
        <h2 class="text-sm font-medium text-green-light mb-2">
          RELATÓRIO DE BENEFICIÁRIOS
        </h2>
        <BeneficiariosReportList ref="list" :filters="filters"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .btn-outline-green {
    border: 1px solid #16a34a;
    color: #16a34a;
    background: #fff;
    padding: 8px 14px;
    border-radius: 3px;
    font-weight: 600;
  }
  .btn-green-solid {
    border: 1px solid #16a34a;
    background: #16a34a;
    color: #fff;
    padding: 8px 18px;
    border-radius: 3px;
    font-weight: 700;
  }
</style>
